import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { adminRetrieveTrainingFollowUps } from "./retrieve-training-follow-ups";
import type { TrainingFollowUpWithUrgenciesVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";

const initialState: RetrievalState<PaginatedResult<TrainingFollowUpWithUrgenciesVM>> = {
  fetching: "idle",
  data: {
    items: [],
    page: 1,
    pageSize: 50,
    total: 0,
    totalPages: 0,
  },
};

export const adminRetrieveTrainingFollowUpsReducer = createReducer<RetrievalState<PaginatedResult<TrainingFollowUpWithUrgenciesVM>>>(
  initialState,
  builder => {
    builder.addCase(adminRetrieveTrainingFollowUps.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(adminRetrieveTrainingFollowUps.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(adminRetrieveTrainingFollowUps.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
  },
);
